import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, Table } from 'reactstrap';
import { useEffect, useState } from 'react';
import { PickupStatsCategories, formatdecider, pickupIsInCategory } from '../../../../helpers';
import { IMatchFinalBoxScoreDto, IRoundBoxScoreDto } from '../../../../WorldDoomLeague';

interface MatchRoundPickupsTableProps {
    activeCategory: PickupStatsCategories;
    perRoundBoxScore: IRoundBoxScoreDto;
    activeRound: number;
};

const MatchRoundPickupsTable = (props: MatchRoundPickupsTableProps) => {
    const [redPlayers, setRedPlayers] = useState<number[]>([]);
    const [bluePlayers, setBluePlayers] = useState<number[]>([]);

    const [redPickups, setRedPickups] = useState<string[]>([]);
    const [bluePickups, setBluePickups] = useState<string[]>([]);

    const getRedTeamPlayers = (boxscore: IRoundBoxScoreDto) => {
        var redPlayers = [] as number[];
        boxscore.redTeamPlayerRoundBoxScore.map((s, idx) => {
            redPlayers.push(s.playerId);
        });

        return redPlayers;
    };

    const getBlueTeamPlayers = (boxscore: IRoundBoxScoreDto) => {
        var bluePlayers = [] as number[];
        boxscore.blueTeamPlayerRoundBoxScore.map((s, idx) => {
            bluePlayers.push(s.playerId);
        });

        return bluePlayers;
    };

    const getRedTeamPickups = (boxscore: IRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.redTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const getBlueTeamPickups = (boxscore: IRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.blueTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const createRedPlayerTableRow = () => {
        var redRows = [];
        var redRow = [];
        redPlayers.map((s, idx) => {
            redRow.push(<th scope="row">{props.perRoundBoxScore.redTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            redPickups.map((t, _idx) => {
                const player = props.perRoundBoxScore.redTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                redRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            redRows.push(<tr className='bg-danger'>{redRow}</tr>);
            redRow = [];
        });


        return (redRows);
    };

    const createBluePlayerTableRow = () => {
        var blueRows = [];
        var blueRow = [];
        bluePlayers.map((s, idx) => {
            blueRow.push(<th scope="row">{props.perRoundBoxScore.blueTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            bluePickups.map((t, _idx) => {
                const player = props.perRoundBoxScore.blueTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                blueRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            blueRows.push(<tr className='bg-primary'>{blueRow}</tr>);
            blueRow = [];
        });

        return (blueRows);
    };

    useEffect(() => {
        setRedPlayers(getRedTeamPlayers(props.perRoundBoxScore));
        setBluePlayers(getBlueTeamPlayers(props.perRoundBoxScore));

        setRedPickups(getRedTeamPickups(props.perRoundBoxScore, props.activeCategory));
        setBluePickups(getBlueTeamPickups(props.perRoundBoxScore, props.activeCategory));
    }, [props.activeCategory, props.activeRound]);

    return (
        <React.Fragment>
            {bluePlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {bluePickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createBluePlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}

            {redPlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {redPickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createRedPlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
};

export default MatchRoundPickupsTable;